import { ChangeDetectionStrategy, Component, inject, LOCALE_ID, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APP_CONFIG, AppConfig } from '../configuration';
import { SupportedLocale } from '../consts/locale';
import { AUTH_CONTEXT_CONFIG, AuthContextConfig } from '@portal-front/portal-auth-shared-util-config';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Component({
  standalone: true,
  imports: [RouterModule],
  providers: [
    {
      provide: AUTH_CONTEXT_CONFIG,
      useFactory: (config: AppConfig, locale: SupportedLocale): AuthContextConfig => ({
        captchaSiteKey: config.googleCaptcha.siteKey,
        registrationUrl: config.urls[locale].registrationUrl,
        userAccountUrl: config.urls[locale].userAccountUrl,
        googleAuthClientId: config.googleAuth.clientId,
        termsUrl: config.urls[locale].termsUrl,
        privacyPolicyUrl: config.urls[locale].privacyPolicyUrl,
        featureFlags: config.featureFlags,
      }),
      deps: [APP_CONFIG, LOCALE_ID],
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'login-app',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'Zaloguj się';

  private readonly gtmService = inject(GoogleTagManagerService);

  public ngOnInit(): void {
    this.gtmService.addGtmToDom();
  }
}
